export enum AuroraCirculationPumpStatus {
  ON = 'on',
  OFF = 'off'
}

export default AuroraCirculationPumpStatus
